var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.size},[_c('span',{staticClass:"ball"}),_c('span',{staticClass:"ball"}),_c('span',{staticClass:"ball"})])}
var staticRenderFns = []

export { render, staticRenderFns }